import axios from "axios";
import authHeader from "./auth-header";
import { API_URL_COMMON } from "./http.common";

const API_URL = `${API_URL_COMMON}/merchants`;
// const API_URL = `https://magicstamp-portal-sa.parktechnology.com/merchants`;

class MerchantService {
  enableMerchant({ account_urn, business_urn }) {
    const config = {
      method: "post",
      url: `${API_URL}/enable`,
      headers: authHeader(null, {
        account_urn,
      }),
      data: { business_urn },
    };
    return axios(config);
  }

  getMerchant({ account_urn }) {
    return axios({
      method: "get",
      url: `${API_URL}`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  getMenus({ account_urn }) {
    return axios({
      method: "get",
      url: `${API_URL}/menus`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  getMenu({ account_urn, menu_urn }) {
    return axios({
      method: "get",
      url: `${API_URL}/menus/${menu_urn}`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  uploadMenu({ account_urn, data }) {
    return axios({
      method: "post",
      url: `${API_URL}/menus/import`,
      headers: authHeader("multipart/form-data", {
        account_urn,
      }),
      data,
    });
  }

  createMenu({ account_urn, data }) {
    return axios({
      method: "post",
      url: `${API_URL}/menus`,
      headers: authHeader(null, {
        account_urn,
      }),
      data,
    });
  }

  updateMenu({ account_urn, menuUrn, data }) {
    return axios({
      method: "patch",
      url: `${API_URL}/menus/${menuUrn}`,
      headers: authHeader(null, {
        account_urn,
      }),
      data,
    });
  }

  deleteMenu({ account_urn, menuUrn }) {
    return axios({
      method: "delete",
      url: `${API_URL}/menus/${menuUrn}`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  createMenuSection({ account_urn, menuUrn, data }) {
    return axios({
      method: "post",
      url: `${API_URL}/menus/${menuUrn}/sections`,
      headers: authHeader(null, {
        account_urn,
      }),
      data,
    });
  }

  updateMenuSection({ account_urn, menuUrn, data }) {
    return axios({
      method: "patch",
      url: `${API_URL}/menus/${menuUrn}/sections`,
      headers: authHeader(null, {
        account_urn,
      }),
      params: { title: data.title },
      data,
    });
  }

  deleteMenuSection({ account_urn, menuUrn, menuSectionUrn }) {
    return axios({
      method: "delete",
      url: `${API_URL}/menus/${menuUrn}`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  createMenuItem({ account_urn, data }) {
    return axios({
      method: "post",
      url: `${API_URL}/products`,
      headers: authHeader(null, {
        account_urn,
      }),
      data,
    });
  }

  updateMenuItem({ account_urn, itemUrn, data }) {
    return axios({
      method: "patch",
      url: `${API_URL}/products/${itemUrn}`,
      headers: authHeader(null, {
        account_urn,
      }),
      data,
    });
  }

  getMenuItems({ account_urn }) {
    return axios({
      method: "get",
      url: `${API_URL}/products`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  addMenutoOutlet({ account_urn, outletUrn, menuUrn }) {
    return axios({
      method: "post",
      url: `${API_URL}/menus/${menuUrn}/link`,
      headers: authHeader(null, {
        account_urn,
      }),
      data: { outletUrn },
    });
  }

  getMenuRewards({ account_urn }) {
    return axios({
      method: "get",
      url: `${API_URL}/menus/rewards`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  createMenuReward({ account_urn, data }) {
    return axios({
      method: "post",
      url: `${API_URL}/menus/rewards`,
      headers: authHeader(null, {
        account_urn,
      }),
      data,
    });
  }

  updateMenuReward({ account_urn, urn, data }) {
    return axios({
      method: "put",
      url: `${API_URL}/menus/rewards`,
      headers: authHeader(null, {
        account_urn,
      }),
      data,
      params: { urn: urn },
    });
  }

  deleteMenuReward({ account_urn, urn }) {
    return axios({
      method: "delete",
      url: `${API_URL}/menus/rewards`,
      headers: authHeader(null, {
        account_urn,
      }),
      params: { urn: urn },
    });
  }

  // ====== DISCOUNTS APIs ======

  getMenuDiscounts({ account_urn }) {
    return axios({
      method: "get",
      url: `${API_URL}/menus/discounts`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  createMenuDiscount({ account_urn, data }) {
    return axios({
      method: "post",
      url: `${API_URL}/menus/discounts`,
      headers: authHeader(null, {
        account_urn,
      }),
      data,
    });
  }

  updateMenuDiscount({ account_urn, urn, data }) {
    return axios({
      method: "put",
      url: `${API_URL}/menus/discounts`,
      headers: authHeader(null, {
        account_urn,
      }),
      data,
      params: { urn: urn }, // Pass urn to identify which discount to update
    });
  }

  deleteMenuDiscount({ account_urn, urn }) {
    return axios({
      method: "delete",
      url: `${API_URL}/menus/discounts`,
      headers: authHeader(null, {
        account_urn,
      }),
      params: { urn: urn }, // Pass urn for deletion
    });
  }

  getMerchantOrders(params) {
    return axios({
      method: "get",
      url: `${API_URL_COMMON}/orders`,
      headers: authHeader(),
      params,
    });
  }

  getMerchantOutlets(businessUrn) {
    return axios({
      method: "get",
      url: `${API_URL}/${businessUrn}/outlets`,
      headers: authHeader(),
    });
  }

  addOutletSecret(businessUrn, data) {
    return axios({
      method: "post",
      url: `${API_URL}/${businessUrn}/outlets`,
      headers: authHeader(),
      data,
    });
  }
}

export default new MerchantService();
